module.exports = __webpack_public_path__ + "assets/img/free_11.0779e240.png";